export default __webpack_public_path__ + "static/webinar-77a6cafaf73fd10a9f4c855f3b508745.jpg";